import React, { useState, Fragment} from 'react'
import ReactFullscreen from "react-full-screen";
import { H3, H2 } from '@blueprintjs/core'
import CustomHr from '../common/CustomHr'
import { translate } from 'utlis/translations/i18n';

const OpenQuestion = ({ results, resource, isLast, selectedName }) => {

    const [fullscreen, setFullscreen] = useState(false)
    return (
        <Fragment>
            <div className="col-xs-12 col-md-12 col-lg-12 open-question-image-result">
                {resource.type !== "VIDEO" && (
                    <ReactFullscreen enabled={fullscreen}>
                        <span className="helper-img"></span>
                        <img
                            className="img-responsive cursor-pointer img-center open-question-image-result"
                            alt="Resource (Pair comparaison)"
                            src={resource.downloadURL}
                            onClick={() => setFullscreen(!fullscreen)}
                        />
                    </ReactFullscreen>
                )}
                {resource.type === "VIDEO" && (
                    <video
                        className="img-responsive open-question-image-result"
                        alt="Resource (Pair comparaison)"
                        src={resource.downloadURL}
                        controls
                        muted
                    />
                )}
                <H2 className="margin-top-large margin-bottom-large text-center new-results">{resource.name}</H2>
            </div>
            <Fragment>
  {(results.verbatims && results.verbatims.length) ? (
    <div style={{ width: '100%' }}>
      {results.verbatims
        .filter(verbatim => verbatim.text !== '' && (!selectedName || verbatim.participantName === selectedName))
        .map((verbatim, i) =>
          <div className="verbatim-open-question-table" key={i}>
            <div style={{borderRight: "1px solid white", width: "100%", minWidth: "100px"}}>
              {verbatim?.participantName || `${translate('respondant')} ${i + 1}` }
            </div>
            <div style={{width: "100%"}}>{verbatim?.text}</div>
          </div>
        )}
    </div>
  ) : (
    <H3 className='margin-top-large new-results text-center'>No user has answered this question yet.</H3>
  )}
</Fragment>
            {isLast ? '' : <div style={{ width: '100%' }}><CustomHr /></div>}
        </Fragment>

    )
}

export default OpenQuestion
